import React, { FC, useState, useEffect } from 'react'
import { IonInput, IonModal, IonHeader, IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { MktButton } from '@cps'
import i18n from 'i18next'
import { indexOf, findIndex } from '@dt/fe-utils/dist/lodash'
import { toast, formatCardNumber } from '@utils'
import { memberMobx, payMobx } from '@mobxStore'
import { storeMobx } from 'restaurant'
import { ddayjs } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  show: boolean;
  onClose: () => void;
  onSave: (info: any) => void;
}

const BindGiftCardModal: FC<IProps> = (props) => {
  const {
    show,
    onClose,
    onSave,
  } = props
  const { getMemberGiftCardDetail } = memberMobx
  const { info } = storeMobx
  const [cardNo, setCardNo] = useState<string>('')
  // Component Event
  const handleClose = () => {
    onClose && onClose()
  }
  const handleFilter = (data: any) => {
    const canStore = data.giftcard.isAllStore || (info.storeId && data.storeIds ? indexOf(data.giftcard.storeIds, info.storeId) > -1 : true)
    if (canStore && data.balance > 0 && (data.expireTime === null || ddayjs(data.expireTime).valueOf() > Date.now()) && data.status === 'enable') {
      onSave && onSave(data)
    } else {
      toast({ message: i18n.t('mkt.common.tipAddGiftCardError') })
    }
  }
  let posting = false
  const handleBinding = () => {
    if (!cardNo) {
      toast({ message: i18n.t('mkt.common.tipCardNumber') })
      return
    }
    if (findIndex(payMobx.giftCards, (item: any) => item.number === cardNo.replace(/\s/g, '')) !== -1) {
      toast({ message: i18n.t('mkt.common.tipAddGiftCardError1') })
      return
    }
    if (posting) return
    posting = true
    getMemberGiftCardDetail({ cardNo }).then((res: any) => {
      if (res) {
        handleFilter(res)
      } else {
        toast({ message: i18n.t('mkt.common.tipAddGiftCardError') })
      }
      posting = false
    }).catch(() => {
      posting = false
    })
  }
  useEffect(() => {
    setCardNo('')
  }, [show])
  return (
    <IonModal
      cssClass='pay-giftcard-modal'
      isOpen={show}
      onDidDismiss={() => handleClose()}
    >
      <IonHeader className='modal-header'>
        <i className='iconfont icon-BACK-12x' data-cypid='cardPayModalClose' onClick={onClose}></i>
      </IonHeader>
      <IonContent>
        <div className='modal-content'>
          <div className='title'>{i18n.t('mkt.giftCard.enterCardNo')}</div>
          <div className='mkt-input'>
            <IonInput maxlength={20} value={cardNo} placeholder={i18n.t('mkt.common.tipCardNumber')} data-cypid='cardPayModalInput' onIonChange={(e: any) => setCardNo(formatCardNumber(e.detail.value))} />
          </div>
          <div className='btn-area'>
            <MktButton text={i18n.t('mkt.common.confirm')} data-cypid='cardPayModalConfirm' disabled={!cardNo} onClick={handleBinding}></MktButton>
          </div>
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(BindGiftCardModal)
